const routes = {
    home: '/',
    contactUs: '/contact',
    aboutUs: '/about',
    courseDetail: '/packagedetail',
}
export default routes;